import * as React from 'react';

import TapNovelWebView from '../../shared/TapNovelWebView';
import MetaTags from '../../shared/MetaTags';

import NavigationProp from '../../../navigators/NavigationProp';

import {getUserAgent} from '../../../../data/data_stores/net/UserAgent';

export interface Params {}

export interface StateProps {
  navigation: NavigationProp;
}

export interface DispatchProps {}

interface Props extends StateProps, DispatchProps {}

const Index: React.FunctionComponent<Props> = props => {
  const [userAgent, setUserAgent] = React.useState<string | null>(null);
  React.useEffect(() => {
    getUserAgent().then(ua => {
      setUserAgent(ua);
    });
    const listener = (event: MessageEvent) => {
      if (typeof event.data === 'string') {
        if (event.data.startsWith('writer_reservation_error/')) {
          const message = event.data.split('/')[1];
          alert(message);
        }
      }
    };
    window.addEventListener('message', listener);
    return () => {
      window.removeEventListener('message', listener);
    };
  }, []);
  return userAgent ? (
    <>
      <MetaTags
        description={
          'TapNovelMaker開発室は、サービス開発の裏側を赤裸々にお見せする会員制のコミュニティです。 主に、新機能開発の進捗やサービス改善のご報告、皆様のご意見やご要望も定期的にお受けしています。'
        }
        keywords={
          'TapNovelMaker開発室,新機能開発,サービス改善,TapNovel,タップノベル,ゲーム小説,イラスト小説,Web小説,無料'
        }
      />
      <TapNovelWebView
        style={{flex: 1}}
        originWhitelist={['*']}
        path={'/writer/community'}
        userAgent={userAgent}
      />
    </>
  ) : null;
};

export default React.memo(Index);
